module.exports = __webpack_public_path__ + "img/left.35e24a76.svg";